import { render, staticRenderFns } from "./AdministrationOverviewItem.vue?vue&type=template&id=04bbba88&"
import script from "./AdministrationOverviewItem.vue?vue&type=script&lang=js&"
export * from "./AdministrationOverviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports